module.exports = __webpack_public_path__ + "img/red_022.b1786706.png";